const defaultSteps = [
  'form.steps.you',
  'form.steps.your_business',
  'form.steps.legal_representative',
  'form.steps.beneficial_owner',
  'form.steps.verification',
];

export default defaultSteps;
